import styled from 'styled-components';
import appStoreBadge from '../assets/img/app-store-badge.svg';
import googlePlayBadge from '../assets/img/google-play-badge.svg';
import { APP_STORE_SMART_LINK } from '../constants';

const WhiteCard = styled.div`
  background: #ffffff;
  border-radius: 8px;
  margin: 0 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: calc(100% - 32px);
  max-width: 360px;
  box-sizing: border-box;
`;

const CardText = styled.p`
  font-family: 'Speedee Regular';
  font-size: 16px;
  color: #2d2d2d;
  line-height: 1.4;
  margin: 0 0 16px;
  max-width: 266px;
`;

const StoreBadges = styled.div`
  display: flex;
  gap: 8px;
`;

const BadgeImg = styled.img`
  height: 42px;
  width: auto;
`;

export default function DownloadApp({ page }) {
  return (
    <WhiteCard>
      <CardText>Join MyMacca's® to get access to future drops and rewards.</CardText>
      <StoreBadges>
        <a
          href={APP_STORE_SMART_LINK}
          target="_blank"
          rel="noreferrer"
          onClick={() =>
            window.gtag?.(
              'event',
              page === 'pre-campaign' ? `mm-early-btn-applestore` : page === 'allclaimed' ? `mm-allclaimed-btn-applestore` : `mm-code-btn-applestore`,
            )
          }>
          <BadgeImg src={appStoreBadge} alt="Download on the App Store" />
        </a>
        <a
          href={APP_STORE_SMART_LINK}
          target="_blank"
          rel="noreferrer"
          onClick={() =>
            window.gtag?.(
              'event',
              page === 'pre-campaign' ? `mm-early-btn-googlestore` : page === 'allclaimed' ? `mm-allclaimed-btn-googlestore` : `mm-code-btn-googlestore`,
            )
          }>
          <BadgeImg src={googlePlayBadge} alt="Get it on Google Play" />
        </a>
      </StoreBadges>
    </WhiteCard>
  );
}
